export default __webpack_public_path__ + "static/Axiforma-Book-f29de93885e76767eb03740ef0eef6b8.woff";